import { uniqueId } from 'lodash-es';
import { GlAvatarLink, GlAvatar, GlTooltip } from '@gitlab/ui';
export default {
    name: 'UserLinkWithTooltip',
    components: {
        GlAvatarLink,
        GlAvatar,
        GlTooltip
    },
    props: {
        avatar: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            toggleId: uniqueId('user-link-')
        };
    }
};
